<template>
  <div :class="['form-control w-full', layout]">
    <label :class="['label', labelLayout]" :style="{ width: labelWidth }" v-if="label" :for="name">
      <span class="label-text">{{ label }}: </span>
    </label>
    <div v-if="disabled" :class="inputLayout">
      <my-input :modelValue="modelValue" disabled readonly></my-input>
    </div>
    <select v-else v-model="value1" :class="[
      'select select-bordered font-normal',
      inputLayout, {
        'select-error': error
      },
    ]" :readonly="readonly">
      <option v-if="nullable" :value="null">{{ placeholder }}</option>
      <option v-for="option in options" :key="option" :value="option" :selected="value1 === option">{{ option }} </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    label: { type: String },
    modelValue: { type: [String, Number], default: () => { return null } },
    options: { type: Array, default: () => { return [] } },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    name: { type: String },
    error: { type: Boolean, default: false },
    placeholder: { type: String, default: 'сонгох..' },
    nullable: { type: Boolean, default: true }
  },
  inject: {
    labelPosition: { type: String, default: 'top' },
    labelWidth: { type: String, default: 'auto' }
  },
  computed: {
    layout () {
      if (this.labelPosition === 'left') {
        return 'flex flex-row space-x-2'
      } else {
        return ''
      }
    },
    labelLayout () {
      if (this.labelPosition === 'left') {
        return 'p-0 flex justify-end items-center text-right'
      } else {
        return ''
      }
    },
    inputLayout () {
      if (this.labelPosition === 'left') {
        return 'flex-1'
      } else {
        return 'w-full'
      }
    },
    value1: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
  }
}
</script>
